import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { IBulkStatusPanelSummary } from "../../stores/bulk-status-panel-store";

interface IProps {
    summary: IBulkStatusPanelSummary;
}

const RmaListBulkStatusPanelSummary: React.FC<IProps> = ({ summary }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";
    const { succeeded, total, needReview } = summary;
    const succeededOfTotal = getTranslation(
        "BULK_STATUS_SUMMARY_SUCCEEDED_OF_TOTAL",
        scope,
        [String(succeeded), String(total)],
    );

    return (
        <FontBody2 color={FONT_COLOR.PRIMARY2}>
            <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                {succeededOfTotal}
            </FontBody2>
            {getTranslation("BULK_STATUS_SUMMARY_MARKED_DONE_CLAUSE", scope)}
            <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                {String(needReview)}
            </FontBody2>
            {getTranslation("BULK_STATUS_SUMMARY_NEED_REVIEW_CLAUSE", scope)}
        </FontBody2>
    );
};

export default RmaListBulkStatusPanelSummary;
